// extracted by mini-css-extract-plugin
export var cardLayout = "_81-1";
export var paginationContainer = "_81-0";